import type { FirestoreEntity, Summary } from './entities';
import type { OrgaUserPermission } from './permission';

export interface OrgaUser {
  orgaId: string;
  orgaName: string;

  userId: string;
  userDisplayName: string | null;
  userInitials: string | null;

  email: string;

  onboardingCompleted: boolean;

  role: OrgaUserPermission;
}

export type FirestoreOrgaUser = FirestoreEntity<OrgaUser>;
export type OrgaUserSummary = Summary;

export function mapOrgaUserSummary(orgaUser: FirestoreOrgaUser) {
  return {
    id: orgaUser.id,
    displayName: orgaUser.data.userDisplayName || 'No Displayname',
  };
}
